import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Summer/MultiplicationAndDivision/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'MultiplicationAndDivision',
  field: 'Number',
  weeks: [1, 3],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/1CountIn2s" */ './1CountIn2s'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/2CountIn10s" */ './2CountIn10s'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/3CountIn5s" */ './3CountIn5s'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/4RecogniseEqualGroups" */ './4RecogniseEqualGroups'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/5AddEqualGroups" */ './5AddEqualGroups'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/6MakeArrays" */ './6MakeArrays'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/7MakeDoubles" */ './7MakeDoubles'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/8MakeEqualGroupsGrouping" */ './8MakeEqualGroupsGrouping'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Summer/MultiplicationAndDivision/9MakeEqualGroupsSharing" */ './9MakeEqualGroupsSharing'
        )
    })
  ]
});
export default Block;
